function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.094 24.525v21.14",
  stroke: "#63C",
  strokeWidth: 3.636,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.094 63.666a5 5 0 110-10 5 5 0 010 10z",
  fill: "#00FFCB",
  stroke: "#63C",
  strokeWidth: 3.636,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.422 76.086C15.156 73.021 3.645 56.541 6.709 39.276 9.774 22.01 26.255 10.498 43.52 13.563a31.605 31.605 0 0114.74 6.833",
  stroke: "#63C",
  strokeWidth: 3.636,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M92.616 67.142L74.902 48.027a4 4 0 00-5.868 0L51.32 67.142c-2.373 2.56-.557 6.719 2.934 6.719h.215a4 4 0 014 4v10.125a4 4 0 004 4h18.998a4 4 0 004-4V77.86a4 4 0 014-4h.215c3.49 0 5.307-4.159 2.934-6.72z",
  stroke: "#63C",
  strokeWidth: 4,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M95.175 57.466l-19.27-20.795a4 4 0 00-5.869 0l-19.27 20.795",
  stroke: "#CCC0FD",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M95.175 47.486L75.905 26.69a4 4 0 00-5.869 0l-19.27 20.795",
  stroke: "#CCC0FD",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M67.114 78.59h4.741m3.825-14.395h-3.825m0 14.394h.3a3.525 3.525 0 003.525-3.525v0a3.525 3.525 0 00-3.018-3.488l-2.53-.368a3.525 3.525 0 01-3.018-3.488v0a3.525 3.525 0 013.525-3.525h1.216m0 14.394v2.99m0-17.384v-2.53",
  stroke: "#63C",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgKvpAvoid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default "data:image/svg+xml;base64,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";
export { SvgKvpAvoid as ReactComponent };